// Marco de celular reutilizable: bisel + barra de estado + isla superior.
// El contenido de la "pantalla" (header de app, cuerpo, barra inferior, etc.) se pasa
// como children — este componente no asume qué app se está mostrando.
function PhoneMockup({ children, className = '' }) {
  return (
    <div
      className={`relative rounded-[2.75rem] border-[3px] border-gray-900 bg-gray-900 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.45)] overflow-hidden ${className}`}
      style={{ fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, system-ui, sans-serif' }}
    >
      {/* Barra de estado + isla superior */}
      <div className="relative bg-gray-900 px-6 pt-2.5 pb-1.5 flex items-center justify-between text-white">
        <span className="text-[11px] font-medium tabular-nums">9:41</span>
        <div className="absolute left-1/2 top-1.5 -translate-x-1/2 h-5 w-24 rounded-full bg-black" />
        <div className="flex items-center gap-1">
          <svg className="h-2.5 w-3.5" viewBox="0 0 16 12" fill="currentColor">
            <rect x="0" y="8" width="3" height="4" rx="0.5" />
            <rect x="4.5" y="5" width="3" height="7" rx="0.5" />
            <rect x="9" y="2" width="3" height="10" rx="0.5" />
            <rect x="13" y="0" width="3" height="12" rx="0.5" />
          </svg>
          <svg className="h-3 w-5" viewBox="0 0 24 12" fill="none">
            <rect x="1" y="1" width="19" height="10" rx="2.5" stroke="currentColor" strokeWidth="1" />
            <rect x="2.5" y="2.5" width="14" height="7" rx="1.5" fill="currentColor" />
            <rect x="21" y="4" width="2" height="4" rx="1" fill="currentColor" />
          </svg>
        </div>
      </div>

      {children}
    </div>
  );
}

export default PhoneMockup;
